import { APPOINTMENT_GUIDE_URL } from './business';

export const APPOINTMENT_GUIDE_LABEL = 'Telecare appointment guide';

export const PAYMENT_NEXT_STEPS = [
  {
    key: 'videoLink',
    title: 'Your video link arrives by SMS and email',
    detail:
      'Sent 3 business days and again 30 minutes before your appointment.',
  },
  {
    key: 'joinFrom',
    title: 'Join from a quiet place with good reception',
    detail: `Read the ${APPOINTMENT_GUIDE_LABEL} so you know what to expect.`,
    linkLabel: APPOINTMENT_GUIDE_LABEL,
    linkUrl: APPOINTMENT_GUIDE_URL,
  },
  {
    key: 'supportingDocuments',
    title: 'We may contact you about supporting documents',
    detail:
      'The Telecare team may be in touch about supporting documents, diagnostic reports or questionnaires needed for this appointment.',
  },
  {
    key: 'medicareClaim',
    title:
      'We lodge your Medicare claim within 3 business days of you attending your appointment',
    detail:
      'Medicare pays any rebate straight into your nominated bank account.',
  },
];

// After booking, before payment matters: the steps that apply to everyone.
const BOOKED_NEXT_STEP_KEYS = ['videoLink', 'joinFrom', 'supportingDocuments'];

export const BOOKED_NEXT_STEPS = PAYMENT_NEXT_STEPS.filter(({ key }) =>
  BOOKED_NEXT_STEP_KEYS.includes(key)
);
